var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlrWarningGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 12.8337C2.69141 12.8337 0 10.1426 0 6.83459C0 3.52478 2.69141 0.832031 5.99902 0.832031C9.30859 0.832031 12.002 3.52478 12.002 6.83459C12.002 10.1426 9.30859 12.8337 5.99902 12.8337ZM5.99902 8.77515C5.70898 8.77515 5.47266 9.0127 5.47266 9.30469C5.47266 9.59668 5.70898 9.83423 5.99902 9.83423C6.28906 9.83423 6.52539 9.59668 6.52539 9.30469C6.52539 9.0127 6.28906 8.77515 5.99902 8.77515ZM5.64746 3.83154V7.71606H6.34766V3.83154H5.64746Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlrWarningGrey);
export default __webpack_public_path__ + "static/media/MLR-Warning-Grey.b5a240ee7e1fa9ed939411fd8d9845e9.svg";
export { ForwardRef as ReactComponent };